import React from 'react'; 

const Footer = () => {

    return (
        <footer>
            © {new Date().getFullYear()}, Built by Allen Welch
        </footer>
    )
}

export default Footer; 